import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
const inputVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("appearance-none w-full px-3 !text-[13px] transition-all outline-none", {
    variants: {
        variant: {
            default: "bg-grayscale-dark h-[32px] rounded-md border border-input focus:border-white/30 focus:ring-0",
            borderless: "border-none focus:border-none focus:ring-0 bg-transparent"
        },
        state: {
            disabled: "opacity-50 cursor-not-allowed"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
const Input = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(({ className, borderless = false, styleless, iconType, iconTrailing, variant, state, isLoading, ...props }, ref)=>{
    if (borderless) variant = "borderless";
    if (props.disabled || isLoading) state = "disabled";
    const input = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
        ref: ref,
        ...props,
        disabled: props.disabled || isLoading,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(styleless ? className : inputVariants({
            variant,
            state,
            className
        }))
    });
    const hasIcon = iconType || iconTrailing;
    const showSpinner = isLoading;
    if (hasIcon || showSpinner) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("relative w-full", className),
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                ref: ref,
                ...props,
                disabled: props.disabled || isLoading,
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(inputVariants({
                    variant,
                    state
                }), className, "!pr-10")
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute right-[9px] z-10 top-[9px] bottom-[9px] transform flex flex-row items-center justify-center pl-[9px] border-l border-white/10",
                children: showSpinner ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    size: 12,
                    className: "opacity-50 animate-spin",
                    type: "spinner"
                }) : iconTrailing ? "string" == typeof iconTrailing ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    size: 12,
                    className: "opacity-50",
                    type: iconTrailing
                }) : iconTrailing : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    size: 12,
                    className: "opacity-50",
                    type: iconType
                })
            })
        ]
    });
    return input;
});
export { Input, inputVariants };
